import { useIsLargeOrBelow } from "@jugl-web/utils/hooks/useMediaQuery";

/**
 * Tells whether the Inbox sidebar (left rail) must render as a static,
 * icon-only compact rail instead of the expandable/pinnable desktop sidebar
 */
export const useIsInboxSidebarCompact = (): boolean => useIsLargeOrBelow();
